const backendURL = import.meta.env.VITE_BACKEND_URL;

export const getWidgetConfigURL = (company_id: string) =>
  backendURL + `widget/widget-config?company_id=${company_id}`;
export const getCompanyURL = backendURL + "widget/company";
export const socketURL = import.meta.env.VITE_SOCKET_URL;

export const getWidgetConversationURL = (
  company_id: string,
  session_id: string,
) =>
  backendURL +
  `widget/conversation?company_id=${encodeURIComponent(company_id)}&session_id=${encodeURIComponent(session_id)}`;

export const getWidgetMessagesURL = (conversation_id: string) =>
  backendURL +
  `widget/messages?conversation_id=${encodeURIComponent(conversation_id)}`;
